// https://transform.tools/json-to-typescript (I used this one)
// http://www.jsontots.com/

import {Observable} from 'rxjs';
import {Id} from "./scenes-interfaces";
import {IEnterpriseBusinessUser} from "./enterprise-business-users-interface";
import {IStationStatsV1} from "./stations-interface";
import {IPrivileges, IStudio, IWhiteLabelSingle} from "./enterprise-interface";

export type serverCallType =
    'CREATE'
    | 'VERIFY_V2'
    | 'SYNC_USER'
    | 'FORGOT_PASS'
    | 'BUSINESS_RENAME'
    | 'CHANGE_PASS'
    | 'LDAP_AUTH'
    | 'STATION_MONITOR'
    | 'SUBSCRIBE_STANDALONE';
export type serverCartCallType =
    'GET_CART_CONTENT'
    | 'ADD_CART_CONTENT'
    | 'REMOVE_CART_CONTENT'
    | 'UPDATE_CART_SHIPPING'
    | 'UPDATE_CHART_STATS'
    | 'CHECKOUT_CREDIT_CARD'
    | 'CHECKOUT_CART_PAYPAL'
    | 'CHECKOUT_CART_WAITING'
    | 'DYNAWEBS'
    | 'ADD_CART_CONTENT_DYNAWEBS'
    | 'REMOVE_CART_CONTENT_DYNAWEBS';

export type AccountType = 'USER' | 'PROVIDER' | 'ENTERPRISE' | 'UNKNOWN';

export type AccountVersion = 'FREE' | 'PLUS' | 'ENTERPRISE_08' | 'ENTERPRISE_24' | 'DASH' | 'UNKNOWN';
export type TypePackages = 'free' | 'plus' | 'enterprise';
export const subscriptionPackages: TypePackages[] = ['free', 'plus', 'enterprise'];

export type StringBinary = '0' | '1' | null;
export type directionType = 'FIRST' | 'LAST' | 'NEXT' | 'PREVIOUS' | 'EXACT';
export type loginUrlType = 'CREATE_ACCOUNT' | 'CHECKOUT' | 'CANVA';
export type pwsInstallsType = 'ios' | 'android' | 'web' | 'windows';

// export enum EnumAccountStatus {
//     ACTIVE,
//     INACTIVE
// }

export enum EnumPricingMethod {
    FREE,
    ENTERPRISE_08,
    PLUS,
    ENTERPRISE_24
}

export enum EnumWizardUpgradeToasts {
    NONE,
    UPGRADE_TO_USE_FEATURE,
    REACHED_LIMIT_OF_FEATURE
}

export enum EnumStationFilterType {
    NONE,
    BUSINESSES,
    STATIONS
}

export enum EnumConnectionType {
    ALL,
    CONNECTED,
    DISCONNECTED
}

export enum EnumApplicationType {
    NOT_SET,
    USER,
    ENTERPRISE
}

export enum EnumLoginStatus {
    LOGIN_PASSED,
    LOGOUT,
    LOGIN_FAILED
}

export enum EnumStudioType {
    PRO,
    LITE,
    SIGN_STUDIO
}

export enum EnumLoginViewMode {
    LOGIN,
    FORGOT_PASSWORD,
    CHANGE_PASSWORD,
    CHANGE_BUSINESS_NAME,
    INIT,
    LOGIN_IN_PROGRESS
}

export enum EnumScheduleRepeatType {
    ONCE,
    YEARLY,
    MONTHLY,
    WEEKLY,
    HOURLY,
    DAILY,
}

export enum ExperienceLevelType {
    BEGINNER = 0,
    ADVANCED = 1
}


export const experienceOptions = [
    { value: ExperienceLevelType.BEGINNER, label: 'general.simpleMode' },
    { value: ExperienceLevelType.ADVANCED, label: 'general.advancedMode' }
];


export interface IGenericObject {
    [key: string]: string;
}

export interface ITimeCounter {
    hours: number;
    minutes: number;
    seconds: number;
    unix: number;
}

export interface IOS {
    info: IOSInfo;
    isBrowser: boolean;
    name1: string;
    name2: string;
    family: string;
    description1: string;
    description2: string;
    uaSting: string;
    isEdge: boolean;
    version: string;
    layout: string;
    os: string;
}

interface IOSInfo {
    description: string;
    layout: string;
    manufacturer: any;
    name: string;
    prerelease: any;
    product: any;
    ua: string;
    version: string;
    os: IOSDetails;
}

interface IOSDetails {
    architecture: number;
    family: string;
    version: string;
}

export interface IEventFinder {
    from: string;
    sceneId: string;
    sceneName: string;
}

export interface IDynawebsServer {
    searchTerm?: string | number;
    updateDate?: string;
    totalLicenses?: number;
    updatesEnabled?: boolean;
    payerId?: number;
    providerId?: number;
    businessName?: string;
    mediaKEY?: number;
    providerUser?: string;
    providerPassword?: string;
    status?: string;
    startDate?: string;
    endDate?: string;
}


export interface IStaticIndexHTML {
    resellerStaticId: number;
    language: string;
}

export interface IPreloadResellerInfo {
    business_id: number;
    custom_studio: string;
    custom_studio_json: IStudio;
    use_white_label: boolean;
    default_privilege_id: number;
    theme_id: number;
    adnet_account_id: number;
}

export interface IDynawebsCustomer {
    user_id: string;
    studio_type: number;
    business_id: number;
    reseller_id: number;
    account_status: number;
    pricing_method: number;
    user_password: string;
    payer_id: number;
    business_name: string;
    source_id: number;
    server: string;
}


export interface IDynawebsServerReply {
    provider_id: number;
    server_id: number;
    unikey_id: number;
    master: boolean;
    source_id: number;
    provider_name: string;
    reseller_licenses: number;
    player_licenses: number;
    enable_updates: boolean;
    provider_user: string;
    provider_password: string;
    payer_id: number;
    status: number;
    provider_ver: number;
    ad_net_access: boolean;
    class_id: any;
    order_date: string;
}

export interface ICart {
    products: Array<ICartProduct>;
    cartContent: Array<ICartProduct>;
    total: any;
    subTotal: number;
    delivery: number;
    tax: number;
    cartLocation: string;
    cartVersion: string;
}

export interface ICartCreate {
    orderId: any; // server side encrypted
    time: string; // epoc time of cart creation
}

export interface ICartRequest {
    serverCall: serverCartCallType;
    user: string;
    password: string;
    cartCreate?: ICartCreate;
    cart?: ICart;
    cartProductId?: number;
    payerId?: number;
    payerIdToken?: string;
    businessIdToken?: string;
    finalOrderId?: string;
    qty?: number;
    price?: number;
    shipping?: string;
    item_notes?: string;
    chargeMode?: boolean;
}

export interface ICartReply {
    cartContent: Array<ICartProduct>;
    cartVersion: string;
    cartLocation: string;
    paypalRedirect?: string;
    cartId?: string;
    billingToken?: string;
    finalOrderId?: string;
    time?: number;
    businessId?: number;
    payerId?: number;
    accountType?: AccountType;
    ccUpdate?: string;
    status?: string | boolean;
}

export interface ICartStoreUpdate {
    total: number;
    subTotal: number;
    tax: number;
    delivery: number;
    cartLocation: string;
    cartVersion?: string;
}

export interface ICartProduct {
    product_id: string;
    name: string;
    description: string;
    inAmazon?: boolean;
    image?: string;
    image_thumb_1?: string;
    image_thumb_2?: string;
    image_thumb_3?: string;
    image_thumb_4?: string;
    image_thumb_5?: string;
    image_thumb_6?: string;
    image_thumb_7?: string;
    image_thumb_8?: string;
    long_description?: string;
    bullets?: string;
    sort_order?: number;
    price: string;
    shipping_points: any;
    stock: string;
    discount: string;
    cost: string;
    active: string;
    product_price?: number;
    item_notes?: string;
    product_count?: number;
    group?: number;
}

export interface IBusinessUsage {
    statsStations: number;
    statsStorage: number;
    statsSockets: number;
}

export interface ISocialReply {
    refId: string;
    title?: string;
    exists?: boolean;
    token?: string;
    paramId?: string;
    url?: string;
    emailSent?: boolean;
    expiresIn?: string;
    message?: string;
    status?: string;
    profileKey?: string;
    createdUTC?: string;
    created?: ISocialReplyCreated;
}

interface ISocialReplyCreated {
    _seconds: number;
    _nanoseconds: number;
}

export interface IOrderForm {
    order_id: number;
    order_id_amazon?: number;
    payer_id: number;
    payment_id?: number;
    id?: string;
    company: string;
    order_date: string;
    subtotal_amount: string;
    comments: string;
    shipping_type: number;
    temp_cart_location: any;
    tax_amount: string;
    amount: string;
    shipping_amount: string;
    temp_paypal_id: any;
    temp_paypal_auth_bearer: any;
    blindship: boolean;
    pl: any;
    po: any;
    serials: any;
    discount_amount: string;
    card_type: number;
    card_number: string;
    security_code: string;
    expiration_month: number;
    expiration_year: number;
    country_code: number;
    info_modified: boolean;
    tel: string;
    mail: string;
    email: string;
    businessName: string;
    billingFirstName: string;
    billingLastName: string;
    billingAddress1: string;
    billingAddress2: string;
    billingCity: string;
    billingState: string;
    billingZip: string;
    billingCountry: string;
    shippingFirstName: string;
    shippingLastName: string;
    shippingAddress1: string;
    shippingAddress2: string;
    shippingCity: string;
    shippingState: string;
    shippingZip: string;
    shippingCountry: string;
    enterpriseUsername: string;
    cellPhone: string;
    status: IPaymentStatus;
    creditCard: string;
    month: string;
    year: string;
    cardType: string;
    expirationDate: string;
    cvc: string;
    user: string;
    password: string;
    confirmPassword: string;
    billingCompany: string;
    shippingCompany: string;
    workPhone: string;
    expirationMonth: string;
    expirationYear: string;
    message: any;
    send: string;
    paid: number;
    taxable: boolean;
    shipping: string;
    tracking: string;
    notes: string;
    billingToken?: string;
    accountStatus?: string;
    pricingMethod?: EnumPricingMethod;

    phone1?: string;
    phone2?: string;
}

export interface IGlobalDataRequest {
    businessId?: string;
    stationId?: string;
    source?: string;
    track?: boolean;
    noBody?: boolean;
}

// export interface IStationTrackReply {
//     station_monitor_id: number;
//     business_id: number;
//     station_id: number;
//     station_business_id: number;
//     reseller?: string;
//     station_tracking_stats_id?: string;
//     connection?: number;
//     date?: string;
// }

export interface IDecryptCredentials {
    user: string;
    pass: string;
    studio: string;
    userType: string;
}

export interface IPaymentStatus {
    name: string;
    value: number;
}

export interface IChangeListIds {
    changelistIdSync: number;
    changelistIdSocket: number;
}

export interface ILockedRecord {
    lockedRecords?: Array<ILockedRecords>;
    changelistId: number;
}

export interface ILockedRecords {
    lockId: Id;
    table: string;
    tableId: any;
}

export interface IEmailSend {
    email: string;
    name: string;
    description: string;
}

export interface IResourcePreview {
    icon: string;
    url: string;
    type: 'image' | 'video' | 'svg' | 'flash' | 'flash_video' | 'sound' | 'none';
    videoUrl?: string;
    show?: boolean;
    resourceId?: string;
    businessId?: string;
    name?: string;
    treePath?: string;
    resourceType?: string;
    byte?: string;
    imported?: boolean;
}

export interface IAccessTableMap {
    [name: string]: IAccessTable;
}

export interface IAccessTable {
    add: boolean;
    del: boolean;
    upd: boolean;
}

export interface ICredentialsWrap {
    result: string;
    returnData: ICredentialsDataWrap[];
}

export interface ICredentialsDataWrap {
    val: string;
    user: IEnterpriseBusinessUser;
    stations: IStationStatsV1;
}

export interface CanComponentDeactivate {
    canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

export interface IBaseBlockComponent {
    submit(formValues);

    componentInit();

    componentStoreUpdates();
}

export interface IAccountRequest {
    serverCall: serverCallType;
    createAccount?: {
        templateId: Id
    };
    verifyAccount?: {
        userName?;
        password?;
        rememberMe?;
        ldapAddress?;
        ldapDomainController?;

    };
    createCustomerAccount?: {
        businessName?;
        userName?;
        password?;
        newPass?;
        templateBusinessId?;
        resellerId?;
        studioType?: EnumStudioType;
        firstName?;
        lastName?;
        contactEmail?;
        workPhone?;
        cellPhone?;
        address?;
        city?;
        state?;
        contry?;
        zipcode?;
        emailUpdates?;
        callback?;
    };
}

export interface IOrderDetails {
    order: IOrderForm;
    shipping?: IOrderShipping;
    billing?: IOrderBilling;
    subscription?: ISubscription;
    orderDetails?: ICartProduct[];
}

interface IOrderShipping {
    payer_id: number;
    first_name: string;
    last_name: string;
    address1: string;
    address2: string;
    city: string;
    state: string;
    country: string;
    zip_code: string;
    phone1: string;
    phone2: string;
    email: string;
    company: string;
}

interface IOrderBilling {
    payer_id: number;
    first_name: string;
    last_name: string;
    address1: string;
    address2: string;
    city: string;
    state: string;
    country: string;
    zip_code: string;
    phone1: string;
    phone2: string;
    email: string;
    card_type: number;
    card_number: string;
    expiration_month: number;
    expiration_year: number;
    country_code: number;
    info_modified: boolean;
    company: string;
    vat?: string;
    card_brand?: string;
    cardholder?: string;
}

export interface ILdap {
    dn: string;
    controls: string;
    objectClass: string;
    userPassword: string;
    cn: string;
    sn: string;
    uid: string;
    mail: string;
    telephoneNumber: string;
}

interface ISubscription {
    payment_id: number;
    description: string;
    amount: string;
    payment_date: string;
    transaction_id: string;
}

export interface IScheduleSelection {
    scheduler: {
        scheduleId: string;
        unique: number;
    };
}

export interface ISchedule {
    schedule_id: string;
    schedule_name: string;
    active?: boolean;
    description?: string;
    event_name?: string;
    specific_days?: Array<string>;
    specific_color?: string;
}

export interface IScheduleEvent {
    schedule_event_id?: string;
    repeat_type: number;         // 0-once, 1-yearly, 2-monthly, 3-weekly, 4-daily
    time: number;                // seconds since midnight
    duration: number;
    event_name: string;
    schedule_id: string;
    weekly_days?: number;        // 1-sun 2-mon 4-tus 8-wen 16-thu 32-fri 64-sat
    repeat_forever?: number;     // 0-false 1-true
    repeat_hourly?: number;
    hourly_offset?: number;
    monthly_offset?: number;
    // elect from 1 ~ 31
    yearly_offset?: number;      // select from 0 ~ 11
    start_date?: string;
    end_date?: string;
    // event_type?: string;      // 1-scene, 0-event
    event_value?: any;           // scene name or event value
    event_source_id?: string;
    enabled?: string;
    priority?: string;
    event_color?: number;
}

export interface IUserSync {
    accountDetails: IOrderForm;
    accountReplyV2: IAccountReplyV2;
    ip?: string;
    status?: 'pass' | 'fail';
}

export interface IAnnualPayData {
    invoice: number;
    firstName: string;
    lastName: string;
    company: string;
    address1: string;
    city: string;
    state: string;
    country: string;
    zipCode: string;
    phone1: string;
    phone2: string;
    email: string;
    cardType: number;
    cardNumber: string;
    securityCode: string;
    expirationMonth: number;
    expirationYear: number;
    terms: number;
    pricingMethod: number;
    stations: number;
    resellerId: string;
    payerId: number;
    paymentDate: string;
    period: string;
    amount: number;
    amountBefore: number;
    monthly: number;
    discount: number;
}

export interface IAccountReplyV2 {
    result: string;
    businessId: Id;
    enterprise?: string;
    businessUserInfo?: IBusinessUserInfo;
    ldap?: ILdap;
    // privilegeId: string;
    // accessMask: string;
}

export interface IBusinessUserInfo {
    name: string;
    privilegeId: string;
    privilegeInfo: IPrivileges;
    accessMask: string;
    businessInfo: IBusinessInfo;
    resellerInfo: IResellerInfo;
    businessDomain?: string;
    socialKey?: string;
    billingToken?: string;
}

interface IBusinessInfo {
    businessId: string;
    name: string;
    description: string;
    accountStatus: string;
    archiveState: string;
    applicationId: EnumApplicationType;
    resellerId: string;
    payerId: string;
    sourceId: string;
    fromTemplateId: string;
    maxMonitors: string;
    maxDataStorage: string;
    studioType: EnumStudioType;
    allowSharing: boolean;
    lastLogin: string;
    loginTime: string;
    webToken;
    string;
}

interface IResellerInfo {
    businessId: string;
    name: string;
    description: string;
    accountStatus: number;
    pricingMethod: EnumPricingMethod;
    archiveState: number;
    applicationId: EnumApplicationType;
    resellerId: number;
    payerId: number;
    providerId: number;
    whiteLabel: boolean;
    customStudio: IWhiteLabelSingle;
}

export interface IBusinessDomainCollection {
    [key: string]: Array<Id>;
}

export interface ISceneTemplateImport {
    studioType: EnumStudioType;
    templateBusinessId: string;
    name: string;
    video: string;
    icon: string | Array<string>;
    preview: string;
    snaps?: Array<string>;
    category?: string;
    touch?: boolean;
}

export interface PlatformStatic {
    description?: string;
    layout?: string;
    manufacturer?: string;
    name?: string;
    prerelease?: string;
    product?: string;
    ua?: string;
    version?: string;
    os?: PlatformOS;

    parse?(ua: string): PlatformStatic;

    toString?(): string;
}

interface PlatformOS {
    architecture?: number;
    family?: string;
    version?: string;

    toString(): string;
}

interface Window {
    platform: PlatformStatic;
}

export interface ICopyPaste {
    Business: CopyPasteBusiness;
}

interface CopyPasteBusiness {
    $: CopyPastetedType;
    Record: CopyPasteRecord[];
}

interface CopyPastetedType {
    id: string;
    saved: string;
}

interface CopyPasteRecord {
    $: CopyPastetedType2;
}

interface CopyPastetedType2 {
    table: string;
    id: string;
    handle: string;
}

export interface ISocialToken {
    profileKey: string;
    refId: string;
}

export interface IUserUpgradeReply {
    saved: boolean;
    charged: boolean;
    message: string;
    credentials?: {
        user: string;
        password: string;
        businessId: string;
        accountType: string;
    };
}

export interface IUserSaveDetailsReply {
    businessId: number;
    resellerId: number;
    resellerUser?: string;
    resellerPass?: string;
    package: TypePackages;
    sourceId: number;
    old: number;
    new: number;
    totalPlayers: number;
    pricingMethod: number;
    amount: number;
    error: string;
    result: boolean;
    payerId?: number;
    removePayer?: boolean;
}

export interface ITwoFactorEnable {
    mode: string;
    userToken: string;
    serverToken: string;
    userName: string;
}

export interface IZivud {
    dateTime: string;
    vehicleId: string;
    userName: string;
    officerId: number;
}

export interface IFeedMeAnyItem {
    text1: string;
    text2: string;
}

export interface IFeedMeAnyDebug {
    rawItemsCount: number;
    normalizedItemsCount: number;
    firstRawItemType: string;
    rawResponse: string;
    cached: boolean;
}

export interface IFeedMeAnyResponse {
    success: boolean;
    items: IFeedMeAnyItem[];
    prompt: string;
    language: string;
    debug?: IFeedMeAnyDebug;
}

declare var platform: PlatformStatic;

